(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-recipe-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
        const button = event.target.closest('[data-cs-recipe-print]');
        if (!button) return;
        window.print();
      });
  } catch(e) { console.error(e); }
})();

})();
